import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TTnaBoardState } from './tna-board.models';

export const getTnaBoardState = (state: TPlani8State) => state.tnaBoardInfo;

export const GetTnaBoardListStore = createSelector(getTnaBoardState, (state: TTnaBoardState) => state.tnaBoardInfo);
